























































































  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import PositionDto from '@/models/Positions/PositionDto';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import Validator from '@/lib/validator';
import CreatePositionRequest from '@/models/Positions/CreatePositionRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'PositionCreate'
})
export default class extends GiganautVueDialog {
 
    public entity = new PositionDto();

    @Watch('dialog')
    onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.entity = new PositionDto();
        }
    }

    get skills() {
        return AgencySettingsModule.skills;
    }

     get industries() {
        return AgencySettingsModule.industries;
    }

     get qualifications() {
        return AgencySettingsModule.qualifications;
    }

    get uniforms() {
        return AgencySettingsModule.uniforms;
    }

    get loading() {
        return AgencySettingsModule.loadingDialog;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        const request = new CreatePositionRequest()
        request.name = this.entity.name;
        request.description = this.entity.description
        request.industryId = this.entity.industry.id
        request.minimumHours = this.entity.minimumHours;
        request.skillIds = this.entity.skills.map(( {id }) => id);
        request.qualificationIds = this.entity.qualifications.map(( {id }) => id);
        request.uniformIds = this.entity.uniforms.map(( {id }) => id);
        await AgencySettingsModule.createPosition(request);
        this.dialog = false;
    }
}
